import React, { useContext } from "react"
import banner from "../../images/feedback.png"
import bannerPC from "../../images/feedback_desktop.png"
import * as styles from "./Styles/Feedback.module.scss"
import { PCViewContext } from "./PCViewContext"

const Feedback = (props) => {
  const isPC = useContext(PCViewContext)
  return (
    <a
      href="https://docs.google.com/forms/d/e/1FAIpQLSfeG6gV8OEjud5jzdnlL33BnzxTghrDOOBM3rqMSbVlyf6E3Q/viewform"
      target="_blank"
      className={styles.linkArea}
    >
      <div className={styles.fullWidth}>
        <img
          src={isPC ? bannerPC : banner}
          className={styles.fullWidth}
          alt="アンケートにご協力ください"
        />
      </div>
    </a>
  )
}

export default Feedback
